import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import Add from '@mui/icons-material/Add';

import { Button } from 'uikit/buttons';
import { Menu } from 'uikit/menus';
import { Typo } from 'uikit/content';

import styles from '../styles/listEmpty.module.scss';

const ListEmpty = ({
  addMenuItems = [],
  body = '',
  bodyVariant = 'b02',
  buttonColor = 'brand',
  buttonText = '',
  buttonType = '',
  buttonVariant = 'default',
  className = '',
  hasAddIcon = true,
  hasAddMenu = false,
  hasButton = false,
  isButtonDisabled = false,
  isButtonTypeAi = false,
  onButtonClick = () => {},
  testId = '',
  title = '',
  titleVariant = 'd03',
}) => {
  const button = (
    <Button
      color={buttonColor}
      icon={hasAddIcon ? <Add /> : ''}
      onClick={hasButton ? onButtonClick : null}
      size="medium"
      text={buttonText}
      variant={buttonVariant}
      isDisabled={isButtonDisabled}
      type={buttonType}
      isTypeAi={isButtonTypeAi}
    />
  );

  return (
    <div className={classnames(styles.container, className)} data-testid={testId}>
      <div className={styles.element}>
        <div className={styles.text}>
          <Typo element="h3" variant={titleVariant}>
            {title}
          </Typo>
          <Typo className={styles.body} color="secondary" variant={bodyVariant}>
            {body}
          </Typo>
        </div>
        {hasAddMenu && (
          <Menu component={button} contentClassName={styles.menu} horizontalPosition="center">
            {addMenuItems}
          </Menu>
        )}
        {hasButton && button}
      </div>
    </div>
  );
};

ListEmpty.propTypes = {
  addMenuItems: PropTypes.node,
  body: PropTypes.string,
  bodyVariant: PropTypes.string,
  buttonColor: PropTypes.string,
  buttonText: PropTypes.string,
  buttonType: PropTypes.string,
  buttonVariant: PropTypes.string,
  className: PropTypes.string,
  hasAddIcon: PropTypes.bool,
  hasAddMenu: PropTypes.bool,
  hasButton: PropTypes.bool,
  isButtonDisabled: PropTypes.bool,
  isButtonTypeAi: PropTypes.bool,
  onButtonClick: PropTypes.func,
  testId: PropTypes.string,
  title: PropTypes.string,
  titleVariant: PropTypes.string,
};

export default React.memo(ListEmpty);
